import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarSign = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(6.6667 0) scale(1.3333)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.00004 0.875C4.34522 0.875 4.62504 1.15482 4.62504 1.5V2.59664C6.28296 2.89183 7.54171 4.34059 7.54171 6.08333C7.54171 6.42851 7.26189 6.70833 6.91671 6.70833C6.57153 6.70833 6.29171 6.42851 6.29171 6.08333C6.29171 5.03435 5.58692 4.14998 4.62504 3.87793V8.42997C6.28296 8.72517 7.54171 10.1739 7.54171 11.9167C7.54171 13.6594 6.28296 15.1082 4.62504 15.4034V16.5C4.62504 16.8452 4.34522 17.125 4.00004 17.125C3.65486 17.125 3.37504 16.8452 3.37504 16.5V15.4034C1.71712 15.1082 0.458374 13.6594 0.458374 11.9167C0.458374 11.5715 0.738196 11.2917 1.08337 11.2917C1.42855 11.2917 1.70837 11.5715 1.70837 11.9167C1.70837 12.9656 2.41316 13.85 3.37504 14.1221V9.57003C1.71712 9.27483 0.458374 7.82608 0.458374 6.08333C0.458374 4.34059 1.71712 2.89183 3.37504 2.59664V1.5C3.37504 1.15482 3.65486 0.875 4.00004 0.875ZM3.37504 3.87793C2.41316 4.14998 1.70837 5.03435 1.70837 6.08333C1.70837 7.13231 2.41316 8.01668 3.37504 8.28874V3.87793ZM4.62504 9.71126V14.1221C5.58692 13.85 6.29171 12.9656 6.29171 11.9167C6.29171 10.8677 5.58692 9.98332 4.62504 9.71126Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgDollarSign);
export default ForwardRef;
